/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { RubricScoringCriterion } from './rubricScoringCriterion';
import type { RubricDimensionOutputParams } from './rubricDimensionOutputParams';

/**
 * Detailed rubric for a single dimension
 */
export interface RubricDimensionOutput {
  /** Name of the dimension */
  name: string;
  /** Maximum points possible for this dimension */
  max_pts: number;
  /** Stored scoring criteria template (may contain placeholders in descriptors) */
  criteria: RubricScoringCriterion[];
  /** Parameters to format into criteria descriptors */
  params?: RubricDimensionOutputParams;
  /** Return the maximum points for stored criteria on this dimension. */
  readonly actual_max_pts: number;
}
